import Contracts from './components/contracts';

export default Contracts;
